import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

import vmslogo from "../../assets/images/vms-logo.png";
import vmslogoCompact from "../../assets/images/vms-logo - compact.png";

const navItems = [
    {
    name: "Visitantes",
    icon: <PeopleOutlinedIcon />,
    path: "/visitor",
    roles: ["superadmin", "admin", "reception"]
  },
  {
    name: "Dashboard",
    icon: <HomeOutlinedIcon />,
    path: "/",
    roles: ["superadmin", "admin", "reception"]
  },
  {
    name: "Reportes",
    icon: <ReceiptIcon />,
    path: "/report",
    roles: ["superadmin", "admin"]
  },
  {
    name: "Usuarios",
    icon: <AdminPanelSettingsIcon />,
    path: "/user",
    roles: ["superadmin"]
  }
];

export default function Sidebar({ mobileOpen, setMobileOpen }) {
  const location = useLocation();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // 🔥 FIX REAL (AQUÍ DEBE ESTAR)
  const role = (localStorage.getItem("user_type") || "").toLowerCase();

  const expanded = !isCollapsed || isHovered;

  return (
    <>
      {/* OVERLAY MOBILE */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <aside
        className={`
          bg-secondary text-white
          fixed md:relative z-50
          h-full md:h-auto
          transition-all duration-300
          ${mobileOpen ? "left-0" : "-left-64"}
          md:left-0
          ${expanded ? "w-56" : "w-16"}
        `}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="p-3">

          {/* LOGO */}
          <div className="flex justify-center items-center mb-6">
            <img
              src={expanded ? vmslogo : vmslogoCompact}
              className="h-10"
              alt="logo"
            />
          </div>

          {/* NAV */}
          {navItems
            .filter((item) => item.roles.includes(role))
            .map((item) => {
              const active = location.pathname === item.path;

              return (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => {
                    setMobileOpen(false);
                    setIsCollapsed(true);
                  }}
                  className={`flex items-center gap-3 p-2 rounded-lg mb-2 transition
                    ${active ? "bg-success text-white" : "hover:bg-accent"}
                  `}
                >
                  <span>{item.icon}</span>

                  {expanded && (
                    <span className="whitespace-nowrap">
                      {item.name}
                    </span>
                  )}
                </Link>
              );
            })}
        </div>
      </aside>
    </>
  );
}